import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';

import { Button } from 'core/components/button';
import { Label } from 'core/components/label';
import { useToast } from 'core/components/toast';
import { InventoryItemCard } from '../inventory-item-card';
import reviewImagesIcon from 'core/assets/svg/ic-review-images.svg';
import inventoryCategories from '../../helpers/inventory-categories';

import useStyles from './inventory-category.styles';

const InventoryCategory = ({ category, items, itemCount }) => {
  const classes = useStyles();
  const toast = useToast();

  const categoryData = inventoryCategories[category];
  const itemLabel = itemCount === 1 ? categoryData.label.singular : categoryData.label.plural;

  const handleOpenAllImages = () => {
    for (let i = 0; i < items.length; i++) {
      window.open(items[i].url, '_blank');
    }
    toast.notify({
      type: 'success',
      message:
        'All of the images in this section have opened in new tabs in your browser. To view them, navigate to each new tab.'
    });
  };

  return (
    <div className={classes.container}>
      <Grid container className={classes.header} justifyContent="space-between" alignItems="center">
        <Grid item className={classes.titleContainer}>
          <Label type="greenBig" className={classes.title}>
            {categoryData.title}
          </Label>
          <div className={classes.totalContainer}>
            <Typography variant="subtitle2" className={classes.totalWord}>
              TOTAL
            </Typography>
            <Typography variant="subtitle2" className={classes.totalValue}>
              {itemCount} {itemLabel}
            </Typography>
          </div>
        </Grid>
        <Grid item>
          <Button
            disableFocusRipple
            className={classes.openAllImagesButton}
            onClick={handleOpenAllImages}
            variant="text"
            color="secondary"
          >
            Open all images
            <img alt="review images icon" className={classes.reviewImagesIcon} src={reviewImagesIcon} />
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        {items.map((item, index) => (
          <Grid item key={index} md={3}>
            <InventoryItemCard
              title={item.title}
              primaryLabel={item.primaryLabel}
              primaryText={item.primaryText}
              imageUrl={item.url}
            >
              {item.content}
            </InventoryItemCard>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

InventoryCategory.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      primaryLabel: PropTypes.string,
      primaryText: PropTypes.node,
      url: PropTypes.string
    })
  ).isRequired,
  category: PropTypes.string.isRequired,
  itemCount: PropTypes.number.isRequired
};

export default InventoryCategory;
